import { Button, SectionCard } from '@datahub/design-system'
import type { PortalContext } from '../lib/types'
import { PortalPage } from './PortalPage'
import { closedMessage } from './phase'

interface StatusPageProps {
  context: PortalContext
  reference: string
  /** Set when the request closed at its deadline. The page then offers no amendment. */
  closedOn: string | null
  onAmend: () => void | Promise<void>
}

/** Shown when the link is opened after a submission (FRM-14). */
export function StatusPage({ context, reference, closedOn, onAmend }: StatusPageProps) {
  const submission = context.submission
  return (
    <PortalPage>
      <div style={{ maxWidth: 560, margin: '0 auto', padding: 48 }}>
        <h1 className="font-jakarta font-bold text-white" style={{ fontSize: 20, lineHeight: '24px', marginBottom: 8 }}>
          Thank you — {context.company.displayName}&rsquo;s update is with Stears
        </h1>
        <p className="font-mulish text-text-support" style={{ fontSize: 12, lineHeight: '22px', marginBottom: 24 }}>
          A Stears analyst will review it and update the company profile. Anything you marked confidential stays in our
          internal records and is never published.
        </p>

        <SectionCard title="Your submission">
          <div className="flex flex-col">
            {[
              ['Reference', reference || submission?.reference || '—'],
              ['Period', context.cycle?.periodLabel ?? '—'],
              ['Submitted', submission ? new Date(submission.submittedAt).toLocaleString('en-GB') : '—'],
              ['Submitted by', submission?.submittedByName ?? '—'],
              ['Version', submission ? String(submission.version) : '—'],
            ].map(([label, value]) => (
              <div key={label} className="flex items-center" style={{ padding: '8px 20px', borderBottom: '0.5px solid #4B5563' }}>
                <span className="font-mulish text-white" style={{ fontSize: 12, width: '42%' }}>{label}</span>
                <span className="font-mulish text-white" style={{ fontSize: 12, flex: 1 }}>{value}</span>
              </div>
            ))}
          </div>
        </SectionCard>

        {closedOn ? (
          <p className="font-mulish text-white" style={{ fontSize: 12, lineHeight: '22px', marginTop: 24 }}>
            {closedMessage(closedOn)}
          </p>
        ) : (
          <div style={{ marginTop: 24, display: 'flex', gap: 10 }}>
            <Button variant="filled-grey" size="medium" onClick={() => void onAmend()}>Update this submission</Button>
          </div>
        )}
        <p className="font-mulish text-text-description" style={{ fontSize: 10, lineHeight: '16px', marginTop: 16 }}>
          Keep this link. You can come back to it whenever something changes, and we will email you when the next update
          is due.
        </p>
      </div>
    </PortalPage>
  )
}
